 import React, { useState } from "react";
import { Table } from "antd";
import { computeRowsAndCols } from "../../../pages/chargers/utils/functions";
import { useNavigate } from "react-router-dom";
import { Chargers } from "pages/chargers/Chargers";
import "./ChargersTable.less"
import useWindowDimensions from "common/functions";

interface ITable {
	data: Chargers
	selectedFilter?: string;
	setNewSort: (value: string) => void;
	shouldReset: (value: boolean) => void;
	reset: boolean;
	offset: number;
	setOffset: (value: number) => void;
	limit: number;
	length: number;
}

const UsersTable: React.FC<ITable> = ({
	offset,
	setOffset,
	data,
	setNewSort,
	shouldReset,
	reset,
	length,
	limit
}) => {

	const navigate = useNavigate();

	const { width } = useWindowDimensions();

	const [isAsc, setIsAsc] = useState({ sessions: false, energyInKWH: false, revenue: false });
	const [isDesc, setIsDesc] = useState({ sessions: false, energyInKWH: false, revenue: false });

	const { columns, rows } = computeRowsAndCols(data,
		navigate,
		(value) => setNewSort(value),
		shouldReset,
		reset,
		isAsc,
		isDesc,
		(value) => setIsAsc(value),
		(value) => setIsDesc(value)
	);
 
	return (
		<Table columns={columns} dataSource={rows} size={width > 1600 ? 'large' : (width > 1200 ? 'middle' : 'small')}
			scroll={{ x: 500 }}
			pagination={{
				total: length,
				current: offset + 1,
				onChange: (page) => setOffset(page - 1),
				defaultPageSize: Number(limit),
				// showSizeChanger: false
			}}
			bordered />
	);
};

export default UsersTable;
